export const FORMATS = {
  "1x1": { w: 1080, h: 1080, label: "1:1 Instagram Post", aspect: "1 / 1" },
  "4x5": { w: 1080, h: 1350, label: "4:5 LinkedIn · IG Portrait", aspect: "4 / 5" },
  "9x16": { w: 1080, h: 1920, label: "9:16 Stories · Reels", aspect: "9 / 16" },
};

export function formatDims(format) {
  return FORMATS[format] || FORMATS["1x1"];
}
